export const PropertyCardSkeleton = () => {
  return (
    <div className="border border-gray-200 rounded-t-xl overflow-hidden animate-pulse">
      {/* IMAGE */}
      <div className="w-full h-48 bg-gray-300" />

      <div className="p-3 space-y-3">
        {/* TITLE */}
        <div className="h-4 bg-gray-300 rounded w-3/4"></div>

        {/* LOCATION */}
        <div className="h-3 bg-gray-200 rounded w-1/2"></div>

        {/* PRICE */}
        <div className="flex items-center gap-2">
          <div className="h-5 bg-gray-300 rounded w-20"></div>
          <div className="h-4 bg-gray-200 rounded w-4"></div>
        </div>

        {/* DESCRIPTION */}
        <div className="space-y-2">
          <div className="h-3 bg-gray-200 rounded w-full"></div>
          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
        </div>

        {/* BUTTON */}
        <div className="h-10 bg-gray-300 rounded-lg w-full"></div>
      </div>
    </div>
  );
};
